import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowSquareDown = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill='none' viewBox='0 0 24 24' {...props} data-sentry-element="svg" data-sentry-component="SvgArrowSquareDown" data-sentry-source-file="ArrowSquareDown.tsx">
            <path fill='currentColor' d='M12 14.91c-.19 0-.38-.07-.53-.22l-3.53-3.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3 3 3-3c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-3.53 3.53c-.15.15-.34.22-.53.22' data-sentry-element="path" data-sentry-source-file="ArrowSquareDown.tsx" />
        </svg>;
};
export default SvgArrowSquareDown;